import React, { ButtonHTMLAttributes } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Container } from './style';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  email: string;
  titulo: string;
  mensagem: string;
  funcao: Function;
}

const BotaoComConfirmacaoConvite: React.FC<ButtonProps> = ({
  email,
  titulo,
  mensagem,
  funcao,
  children,
  ...rest
}) => {
  const submit = () => {
    confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: 'Enviar',
          onClick: () => funcao(email),
        },
        {
          label: 'Cancelar',
          onClick: () => (0),
        },
      ],
    });
  };

  return (
    <Container type="button" title={titulo} onClick={submit} {...rest}>
      {children}
    </Container>
  );
};

export default BotaoComConfirmacaoConvite;
